import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

import { useLanguage } from "../i18n/LanguageContext";

import "./styles/readArticle.css";

const ReadArticle = () => {
	const navigate = useNavigate();
	const { slug } = useParams();
	const { messages, t, locale } = useLanguage();

	const idx = Number(slug) - 1;
	const article = messages.articles[idx];

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [slug, locale]);

	useEffect(() => {
		if (
			!article ||
			Number.isNaN(idx) ||
			idx < 0 ||
			idx >= messages.articles.length
		) {
			navigate("/");
		}
	}, [article, idx, messages.articles.length, navigate]);

	if (!article) {
		return null;
	}

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${article.title} | ${t("main.siteTitle")}`}</title>
				<meta name="description" content={article.description} />
				<meta
					name="keywords"
					content={article.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="articles" />

				<div className="content-wrapper">
					<div className="read-article-container">
						<div className="read-article-back">
							<img
								src="../back-button.png"
								alt="back"
								className="read-article-back-button"
								onClick={() => navigate(-1)}
							/>
						</div>

						<div className="read-article-wrapper">
							<div className="read-article-date-container">
								<div className="read-article-date">
									{article.date}
								</div>
							</div>

							<div className="title read-article-title">
								{article.title}
							</div>

							<div className="read-article-body">{article.body}</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ReadArticle;
